"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Boolean: function() {
        return Boolean;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Boolean = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M9 23C7.61553 23 6.26216 22.5895 5.11101 21.8203C3.95987 21.0511 3.06266 19.9579 2.53285 18.6788C2.00303 17.3997 1.86441 15.9922 2.13451 14.6344C2.4046 13.2765 3.07129 12.0292 4.05026 11.0503C5.02922 10.0713 6.2765 9.4046 7.63437 9.13451C8.99224 8.86441 10.3997 9.00303 11.6788 9.53285C12.9579 10.0627 14.0511 10.9599 14.8203 12.111C15.5895 13.2622 16 14.6155 16 16C15.9979 17.8559 15.2597 19.6351 13.9474 20.9474C12.6351 22.2597 10.8559 22.9979 9 23ZM9 11C8.0111 11 7.0444 11.2932 6.22215 11.8427C5.39991 12.3921 4.75904 13.173 4.38061 14.0866C4.00217 15.0002 3.90315 16.0056 4.09608 16.9755C4.289 17.9454 4.76521 18.8363 5.46447 19.5355C6.16373 20.2348 7.05465 20.711 8.02455 20.9039C8.99446 21.0969 9.99979 20.9978 10.9134 20.6194C11.8271 20.241 12.6079 19.6001 13.1574 18.7779C13.7068 17.9556 14 16.9889 14 16C13.9984 14.6744 13.4711 13.4036 12.5338 12.4662C11.5964 11.5289 10.3256 11.0016 9 11Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M23 23C26.866 23 30 19.866 30 16C30 12.134 26.866 9 23 9C19.134 9 16 12.134 16 16C16 19.866 19.134 23 23 23Z",
            fill: "currentColor"
        })
    ]
}), "Boolean");
const _default = Boolean;
